import React, { Fragment } from 'react'

import PropTypes from 'prop-types'

import './steps2.css'

const Steps2 = (props) => {
  return (
    <div className="steps2-container1 thq-section-padding">
      <div className="steps2-max-width thq-section-max-width">
        <div className="steps2-container2 thq-grid-2">
          <div className="steps2-section-header">
            <h2 className="thq-heading-2">
              Discover the Power of Our Products
            </h2>
            <p className="thq-body-large">
              Our AI-powered sign language translation solutions bridge the gap
              between the Deaf community and the hearing world. We provide
              seamless, real-time, and bidirectional sign language
              interpretation, enabling governments and enterprises to create
              truly inclusive environments.
            </p>
            <div className="steps2-actions">
              <button className="thq-button-filled thq-button-animated steps2-button">
                <a
                  href="mailto:admin@signbridge.com?subject=Connect to our team"
                  className="steps2-text12 thq-body-small"
                >
                  Contact Us
                </a>
              </button>
            </div>
          </div>
          <div className="steps2-container3">
            <div className="steps2-container4 thq-card">
              <h2 className="thq-heading-2">
                {props.step1Title ?? (
                  <Fragment>
                    <span className="steps2-text25">Meet Our Team Members</span>
                  </Fragment>
                )}
              </h2>
              <span className="steps2-text14 thq-body-small">
                {props.step1Description ?? (
                  <Fragment>
                    <span className="steps2-text33">
                      Get to know the talented individuals behind Signbridge AI
                      who are dedicated to revolutionizing accessibility and
                      breaking communication barriers.
                    </span>
                  </Fragment>
                )}
              </span>
              <label className="steps2-text15 thq-heading-3">01</label>
            </div>
            <div className="steps2-container5 thq-card">
              <h2 className="thq-heading-2">
                {props.step2Title ?? (
                  <Fragment>
                    <span className="steps2-text26">
                      Partnership Opportunities
                    </span>
                  </Fragment>
                )}
              </h2>
              <span className="steps2-text17 thq-body-small">
                {props.step2Description ?? (
                  <Fragment>
                    <span className="steps2-text35">
                      We are actively seeking government and enterprise partners
                      who are interested in leveraging our AI-powered solution
                      for real-time sign language translation.
                    </span>
                  </Fragment>
                )}
              </span>
              <label className="steps2-text18 thq-heading-3">02</label>
            </div>
            <div className="steps2-container6 thq-card">
              <h2 className="thq-heading-2">
                {props.step3Title ?? (
                  <Fragment>
                    <span className="steps2-text27">Future Development</span>
                  </Fragment>
                )}
              </h2>
              <span className="steps2-text20 thq-body-small">
                {props.step3Description ?? (
                  <Fragment>
                    <span className="steps2-text28">
                      Stay tuned for our upcoming VR/AR solutions that will
                      further enhance accessibility and communication for
                      individuals using sign language.
                    </span>
                  </Fragment>
                )}
              </span>
              <label className="steps2-text21 thq-heading-3">03</label>
            </div>
            <div className="steps2-container7 thq-card">
              <h2 className="thq-heading-2">
                {props.step4Title ?? (
                  <Fragment>
                    <span className="steps2-text34">
                      Our Vision for the Future
                    </span>
                  </Fragment>
                )}
              </h2>
              <span className="steps2-text23 thq-body-small">
                {props.step4Description ?? (
                  <Fragment>
                    <span className="steps2-text29">
                      <span>
                        We envision a future where accessibility is the
                        standard.
                      </span>
                      <br></br>
                      <span>
                        Our goal is to become the leading unicorn in AI for
                        Accessibility, driving innovation in sign language
                        recognition, generation, and beyond—building an
                        inclusive world for all.
                      </span>
                    </span>
                  </Fragment>
                )}
              </span>
              <label className="steps2-text24 thq-heading-3">04</label>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

Steps2.defaultProps = {
  step1Title: undefined,
  step2Title: undefined,
  step3Title: undefined,
  step3Description: undefined,
  step4Description: undefined,
  step1Description: undefined,
  step4Title: undefined,
  step2Description: undefined,
}

Steps2.propTypes = {
  step1Title: PropTypes.element,
  step2Title: PropTypes.element,
  step3Title: PropTypes.element,
  step3Description: PropTypes.element,
  step4Description: PropTypes.element,
  step1Description: PropTypes.element,
  step4Title: PropTypes.element,
  step2Description: PropTypes.element,
}

export default Steps2
